import { getState, setState, storage, subscribe } from './app/store'
import { remountPage } from './app/lifecycle'

/**
 * Footer "off" / "on": the easy view without photos, VHS look, animations or
 * the game. Sliders render as plain lists, so page modules are remounted to
 * rebuild themselves in the other view. The initial value is set before first
 * paint by the inline script in header.php (stored choice, else the OS
 * "reduce motion" setting).
 */
const STORAGE_KEY = 'danino:easy-mode'

const syncButtons = (easyMode) => {
  document.querySelectorAll('[data-easy-mode-toggle]').forEach((button) => {
    button.setAttribute('aria-pressed', String(easyMode))
  })
}

export function startEasyMode() {
  syncButtons(getState().easyMode)

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-easy-mode-toggle]')) return
    const easyMode = !getState().easyMode
    storage.set(STORAGE_KEY, easyMode ? '1' : '0')
    setState({ easyMode })
  })

  subscribe((state, changed) => {
    if (!changed.includes('easyMode')) return
    syncButtons(state.easyMode)
    remountPage()
  })
}
